import React from 'react';
import ReactTable from 'react-table';
import { Field, change } from 'redux-form';
import { CheckboxField } from 'Common/SemanticWrapper';
import { USER_ACCESS_ROLE_FORM } from 'Common/FormEnum';

import { accessRowToFieldId } from '../helpers';

export const Preferences = ({ data = [], dispatch }) => {
  return (
    <div className="group-function--preferences">
      <ReactTable
        data={data}
        pageSize={data.length}
        className="-striped -highlight"
        showPagination={false}
        columns={[
          {
            Header: 'Preferences',
            columns: [
              {
                Header: '',
                accessor: 'FunctionName',
              },
              {
                Header: '',
                id: 'Preferences',
                accessor: '',
                className: 'column--checkbox',
                Cell: ({ original }) => {
                  const Id = accessRowToFieldId(original);
                  return (
                    <Field
                      component={CheckboxField}
                      name={`AllowWrite${Id}`}
                      onClick={(e, { checked }) => {
                        e.preventDefault();
                        dispatch(
                          change(
                            USER_ACCESS_ROLE_FORM,
                            `AllowWrite${Id}`,
                            checked
                          )
                        );
                      }}
                    />
                  );
                },
                maxWidth: 100,
                filterMethod: (filter, rows) => false,
              },
            ],
          },
        ]}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/components/Preferences.js